import { Expose } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator';
import { MfaType } from '../../enums/auth';

export class MfaSetupResponseDto {
    @Expose()
    @IsUUID()
    @IsNotEmpty()
    id: string;

    @Expose()
    @IsEnum(MfaType)
    @IsNotEmpty()
    methodType: MfaType;

    @Expose()
    @IsOptional()
    @IsString()
    otpAuthUri?: string;

    @Expose()
    @IsOptional()
    @IsString()
    secretKey?: string;
}
